import { MenuItem as MenuItemMui } from '@mui/base/MenuItem';
import { Icon, enums } from 'edrolo-ui';
import { ProfileMenuItem as IProfileMenuItem } from '../../../NavBar';

import styles from './styles.scss';

interface MenuItemProps {
  menuItem: IProfileMenuItem;
}

export const ProfileMenuItem = ({
  menuItem,
}: MenuItemProps): JSX.Element | null => {
  const { href, title, iconName, callback } = menuItem;

  return (
    <MenuItemMui>
      <a role="menuItem" href={href} className={styles.link} onClick={callback}>
        {iconName && <Icon name={iconName} size={enums.Size.LARGE} />}
        {title}
      </a>
    </MenuItemMui>
  );
};
